import { Component, Input, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-back-button',
    standalone: true,
    imports: [RouterModule],
    templateUrl: './back-button.component.html',
    styleUrls: ['./back-button.component.css'],
})
export class BackButtonComponent implements OnInit {

    @Input() backgroundColor: string
    @Input() iconColor: string

    constructor() { }

    ngOnInit(): void {
    }

}
